import type { ObjectPlugin } from "@vue/runtime-core";

import { $datetime, DatetimePlugin } from "./datetime";
import { $decimal, type DecimalPlugin } from "./decimal";
import { $format, type FormatPlugin } from "./format";
import { $utils, UtilsPlugin } from "./utils";
import { $device, DevicePlugin } from "./device";

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $decimal: DecimalPlugin;
    $format: FormatPlugin;
    $datetime: DatetimePlugin;
    $utils: UtilsPlugin;
    $device: DevicePlugin;
  }
}

export {}; // Important

const plugins: ObjectPlugin[] = [$decimal, $format, $datetime, $utils, $device];

export const $plugins: ObjectPlugin = {
  install: (app, options) => {
    plugins.forEach((plugin) => {
      plugin.install(app, options);
    });
  },
};
